import styled from "styled-components";
import { ICheckBoxProps } from "./type";

const Input = styled.input<ICheckBoxProps>`
	border: 1px solid #d9d9d9;
	border-radius: 5px;
	opacity: 1;
	display: block;
	height: 29px;
	width: 28px;
	${(props) =>
		props.customSize === "small" &&
		`
    height: 21px;
    width: 20px;
  `}
`;

const Label = styled.label<ICheckBoxProps>`
	text-align: left;
	font: normal normal normal 18px/22px Lato;
	letter-spacing: 0px;
	opacity: 1;
	${(props) =>
		props.customSize === "small" &&
		`
    font-size: 16px;
    line-height: 20px;
  `}
`;

export default {
	Input,
	Label,
};
